<template>
<div>
  <v-layout v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <!-- ADD STUDENT -->
  <v-layout v-else-if="adding" row wrap justify-center>
    <v-flex class="text-xs-center py-3" xs11>
      <v-btn @click.native="adding = false" color="error" flat large icon><v-icon>close</v-icon></v-btn>
      <v-divider class="mt-3"></v-divider>
    </v-flex>
    <v-flex class="text-xs-center" xs12 md8>
      <v-text-field
        class="elevation-1"
        label="Search for Student"
        @keyup.enter="search"
        v-model.trim="searchQuery"
        prepend-icon="search"
        :append-icon="searchQuery.length > 0 ? 'close' : ''"
        :append-icon-cb="() => (searchQuery = '', listed = [])"
        solo
      ></v-text-field>
    </v-flex>
    <v-flex xs6 md2>
      <v-btn @click.native="search" class="my-0 elevation-0" color="success" block large flat>
        <b>Search</b>
      </v-btn>
    </v-flex>
    <v-flex v-if="listed.length == 0" class="py-5" xs12>
      <div class="text-xs-center pt-3 pb-5 display-3 grey--text text--lighten-1">None</div>
    </v-flex>
    <template v-else>
      <v-flex class="px-2 py-4 text-xs-center secondary--text title" xs12>
        <div class="title pb-2"><b>{{listed.length}}{{listed.length == 1 ? ' users' : ' users'}}</b></div>
        <div class="subheading"><b>20 users per page</b></div>
      </v-flex>
      <v-flex class="px-2 pb-3" xs12 md8>
        <v-layout row>
          <v-flex class="text-xs-right" xs>
            <v-btn
              @click.native="currentSearchPage = currentSearchPage - 1"
              class="my-0"
              color="primary"
              :disabled="currentSearchPage == 0"
              icon
              flat
            ><b><v-icon medium>chevron_left</v-icon></b></v-btn>
          </v-flex>
          <v-flex xs>
            <v-menu max-height="300px" full-width offset-y>
              <v-btn slot="activator" color="primary" class="my-0" flat block>
                <span><b>Page {{currentSearchPage + 1}}</b></span>
              </v-btn>
              <v-list>
                <template v-for="p, i in searchPages">
                  <v-list-tile v-if="currentSearchPage == i" :key="i">
                    <v-list-tile-title class="grey--text text--lighten-1">
                      <b>Page {{ i+1 }}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-else :key="i" @click="currentSearchPage = i">
                    <v-list-tile-title>
                      <b>Page {{ i+1 }}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex class="text-xs-left" xs>
            <v-btn
              @click.native="currentSearchPage = currentSearchPage + 1"
              class="my-0"
              color="primary"
              :disabled="(currentSearchPage + 1) == searchPages.length"
              icon
              flat
            ><b><v-icon medium>chevron_right</v-icon></b></v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="px-2 pb-3" xs12 md10>
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-content class="mb-3" v-for="u, i in searchPages[currentSearchPage]" :key="i">
            <div slot="header">
              <div class="title secondary--text">
                <span><b>{{u.firstName + ' ' + u.lastName}}</b></span>
              </div>
              <div class="subheading">
                <span><b>{{u.email}}</b></span>
              </div>
            </div>
            <v-card>
              <v-layout row wrap>
                <v-flex class="pb-1 pl-2" xs12>
                  <v-btn :to="'/users/' + u.uid" class="my-0" color="primary" flat small><b>View Student</b></v-btn>
                  <v-btn
                    @click.native="studentData = u, popup.show = true, popup.type = 'Add Student'"
                    class="my-0" 
                    color="success" 
                    flat 
                    small
                  ><b>Add Student</b></v-btn>
                </v-flex>
                <v-flex class="pb-1 pl-4" xs12>
                  <div><b>User Type:</b> {{u.type}}</div>
                  <div><b>Sign Up Date: </b> {{(new Date(u.dateCreated)).toLocaleDateString()}} at {{(new Date(u.dateCreated)).toLocaleTimeString()}}</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </template>
  </v-layout>
  <!-- STUDENT LIST -->
  <v-layout v-else class="py-3 px-2" row wrap justify-center>
    <v-flex class="pb-3 text-xs-center" xs11>
      <v-btn
        @click.native="adding = true"
        color="success"
        :disabled="students.length >= parseInt(courseData.maxStudents)"
        depressed
        large
      ><b>Add Student</b></v-btn>
      <v-divider class="my-3"></v-divider>
    </v-flex>
    <v-flex v-if="students.length == 0" class="py-5" xs12>
      <div class="text-xs-center pb-5 display-3 grey--text text--lighten-1">No Students</div>
    </v-flex>
    <template v-else>
      <v-flex class="px-2 pb-4 text-xs-center secondary--text title" xs12>
        <div class="title pb-2"><b>{{students.length}}{{students.length == 1 ? ' student' : ' students'}}</b></div>
        <div class="subheading"><b>20 students per page</b></div>
      </v-flex>
      <v-flex class="px-2 pb-3" xs12 md8>
        <v-layout row>
          <v-flex class="text-xs-right" xs>
            <v-btn
              @click.native="currentStudentPage = currentStudentPage - 1"
              class="my-0"
              color="primary"
              :disabled="currentStudentPage == 0"
              icon
              flat
            ><b><v-icon medium>chevron_left</v-icon></b></v-btn>
          </v-flex>
          <v-flex xs>
            <v-menu max-height="300px" full-width offset-y>
              <v-btn slot="activator" color="primary" class="my-0" flat block>
                <span><b>Page {{currentStudentPage + 1}}</b></span>
              </v-btn>
              <v-list>
                <template v-for="p, i in studentPages">
                  <v-list-tile v-if="currentStudentPage == i" :key="i">
                    <v-list-tile-title class="grey--text text--lighten-1">
                      <b>Page {{ i+1 }}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-else :key="i" @click="currentStudentPage = i">
                    <v-list-tile-title>
                      <b>Page {{ i+1 }}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex class="text-xs-left" xs>
            <v-btn
              @click.native="currentStudentPage = currentStudentPage + 1"
              class="my-0"
              color="primary"
              :disabled="(currentStudentPage + 1) == studentPages.length"
              icon
              flat
            ><b><v-icon medium>chevron_right</v-icon></b></v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="px-2 pb-3" xs12 md10>
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-content class="mb-3" v-for="s, i in studentPages[currentStudentPage]" :key="i">
            <div slot="header">
              <div class="title secondary--text">
                <span><b>{{s.firstName}} {{s.lastName}}</b></span>
              </div>
              <div class="subheading">
                <span><b>{{s.email}}</b></span>
              </div>
            </div>
            <v-card>
              <v-layout row wrap>
                <v-flex class="pb-1 pl-2" xs12>
                  <v-btn :to="'/users/' + s.uid" class="my-0" color="primary" flat small><b>View</b></v-btn>
                  <v-btn :to="'/progress/' + s.uid" class="my-0" color="primary" flat small><b>Progress</b></v-btn>
                  <v-btn @click.native="studentData = s, popup.type = 'Remove Student', popup.show = true" class="my-0" color="error" flat small><b>Remove</b></v-btn>
                </v-flex>
                <v-flex class="pb-1 pl-4" xs12>
                  <div><b>Registered for:</b> {{s.courseName}}</div>
                  <div><b>Course type:</b> {{s.subject}}, {{s.onlineDays + ' days online'}}</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </template>
  </v-layout>

  <r-course-popup
    :popup="popup"
    :new-course="courseData"
    :student-data="studentData"
  ></r-course-popup>
</div>
</template>

<script>
import {coursesEvent} from '../../main'
import CoursePopup from './CoursePopup.vue'
export default {
  components: {
    rCoursePopup: CoursePopup
  },
  data: () => ({
    loading: false,
    searching: false,
    adding: false,
    updating: false,
    courseData: {},
    newCourse: {},
    studentData: {},
    students: [],
    studentIds: [],
    studentPages: [],
    currentStudentPage: 0,
    searchQuery: '',
    listed: [],
    searchPages: [],
    currentSearchPage: 0,
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    this.load()
    coursesEvent.$on('addStudent', () => {
      this.addStudent()
    })
    coursesEvent.$on('removeStudent', () => {
      this.removeStudent()
    })
  },
  computed: {
    now () {
      return this.$store.getters.now
    },
    progress () {
      return this.$store.getters.progress
    }
  },
  methods: {
    load () {
      this.loading = true
      this.adding = false
      this.searchQuery = ''
      this.listed = []
      this.searchPages = []
      this.currentSearchPage = 0
      this.courseData = this.$store.getters.courseByKey(this.$route.params.courseKey)
      this.resetNewCourse()
      this.getStudents()
      this.loading = false
    },
    resetNewCourse () {
      this.newCourse = {
        ...this.courseData,
        content: this.courseData.content ? [...this.courseData.content] : [],
        dates: this.courseData.dates ? [...this.courseData.dates] : [],
        students: this.courseData.students ? [...this.courseData.students] : []
      }
    },
    getStudents () {
      this.students = []
      let student = {}
      let studentIds = []
      const linked = this.$store.getters.linkedCourses(this.courseData.key)
      for (let course of linked) {
        if (course.students) {
          for (let studentId of course.students) {
            if (!studentIds.includes(studentId) && this.hasProgress(studentId)) {
              studentIds.push(studentId)
              student = {
                uid: studentId,
                firstName: this.$store.getters.userById(studentId).firstName,
                lastName: this.$store.getters.userById(studentId).lastName,
                email: this.$store.getters.userById(studentId).email,
                courseName: course.name,
                subject: course.subject,
                onlineDays: course.onlineDays
              }
              this.students.push(student)
            }
          }
        }
      }
      // create pages
      this.studentPages = []
      let i = 0
      let pageNum = 0
      while (i < this.students.length) {
        this.studentPages.push([])
        while (this.studentPages[pageNum].length < 20) {
          if (i === this.students.length) break
          this.studentPages[pageNum].push({...this.students[i]})
          i++
        }
        pageNum++
      }
      this.currentStudentPage = 0
    },
    search () {
      this.listed = []
      if (this.searchQuery === '') return
      this.searching = true
      let users = this.$store.getters.users
      for (let u of users) {
        if (!this.hasProgress(u.uid) && u.data.toLowerCase().includes(this.searchQuery.toLowerCase())) this.listed.push(u)
      }
      // create pages
      this.searchPages = []
      let i = 0
      let pageNum = 0
      while (i < this.listed.length) {
        this.searchPages.push([])
        while (this.searchPages[pageNum].length < 20) {
          if (i === this.listed.length) break
          this.searchPages[pageNum].push({...this.listed[i]})
          i++
        }
        pageNum++
      }
      this.currentStudentPage = 0
      this.searching = false
    },
    addStudent () {
      this.updating = true
      if (!this.hasProgress(this.studentData.uid)) {
        const linked = this.$store.getters.linkedCourses(this.courseData.key)
        let exists = false
        for (let c of linked) {
          if (c.students) {
            if (c.students.includes(this.studentData.uid)) exists = true
          }
        }
        let newProgress = {
          name: this.courseData.name,
          courseKey: this.courseData.key,
          studentId: this.studentData.uid,
          onlineDays: this.courseData.onlineDays,
          endTime: 0
        }
        this.$store.dispatch('createProgress', newProgress).then(() => {
          let appMsg = {
            type: 'success',
            msg: 'Added ' + this.studentData.firstName + ' ' + this.studentData.lastName + ' in ' + this.courseData.name
          }
          if (!exists && this.studentData.type.toLowerCase() === 'student') {
            let newCourse = {
              ...this.courseData,
              students: this.courseData.students ? [...this.courseData.students] : []
            }
            newCourse.students.push(this.studentData.uid)
            this.$store.dispatch('updateCourse', newCourse).then(() => {
              this.$store.dispatch('showAppMsg', appMsg)
              this.updating = false
              this.load()
            })
          } else {
            this.$store.dispatch('showAppMsg', appMsg)
            this.updating = false
            this.load()
          }
        }).catch(err => {
          let appMsg = {
            type: 'error',
            msg: err.message
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.updating = false
        })
      } else {
        let appMsg = {
          type: 'error',
          msg: 'That student already has this course or a course linked to this one'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.updating = false
      }
    },
    removeStudent () {
      let p = this.$store.getters.progressByCourseByStudent(this.courseData.key, this.studentData.uid)
      let maxEndTime = -1
      let rightProgress = {}
      for (let progress of p) {
        if (progress.endTime === 0 || progress.endTime > maxEndTime) {
          rightProgress = {...progress}
          maxEndTime = progress.endTime
        }
      }
      rightProgress.endTime = this.now
      this.$store.dispatch('updateProgress', rightProgress).then(() => {
        this.getStudents()
        let appMsg = {
          type: 'success',
          msg: 'Student removed successfully'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    hasProgress (uid) {
      const linkedKeys = []
      for (let c of this.$store.getters.linkedCourses(this.courseData.key)) {
        linkedKeys.push(c.key)
      }
      let rightProgress = false
      let notEnded = false
      for (let p of this.progress) {
        rightProgress = p.studentId === uid && linkedKeys.includes(p.courseKey)
        notEnded = p.endTime === 0 || this.now < p.endTime
        if (rightProgress && notEnded) return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/StudentList.vue